import { z } from "zod";
import { cursorPaginatedResponseSchema, DateSchema, IdSchema } from "./commonSchema";
import type { CursorPaginatedResponse } from "@/types/common";

export const AuditLogSchema = z.object({
  id: IdSchema,
  action: z.string(),
  entityType: z.string(),
  entityId: IdSchema,
  changes: z.record(z.unknown()).nullable(),
  performedBy: IdSchema,
  performedByName: z.string(),
  createdAt: DateSchema,
});

export type AuditLog = z.infer<typeof AuditLogSchema>;

export type AuditLogListResponse = CursorPaginatedResponse<AuditLog>;

export const AuditLogListResponseSchema = cursorPaginatedResponseSchema(AuditLogSchema);
